import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { useMemo } from "react";

import { NewsFeedItemCommentItem } from "./CommentItem";
import { type NewsFeedItemComment } from "./types";

export interface NewsFeedItemCommentListProps {
  comments: NewsFeedItemComment[];
}

export function NewsFeedItemCommentList(props: NewsFeedItemCommentListProps) {
  const { comments } = props;

  const sortedComments = useMemo(() => {
    return [...comments].sort(
      (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
    );
  }, [comments]);

  return (
    <Stack alignItems="center" p={2} spacing={5} overflow="auto">
      {sortedComments.map((comment) => (
        <NewsFeedItemCommentItem key={comment.id} comment={comment} />
      ))}
      {comments.length === 0 && (
        <Text color={(theme) => theme.palette.text.tertiary}>No comments yet, be the first!</Text>
      )}
    </Stack>
  );
}
